import type { VFC } from 'react'
import KeyValueDisplay from './common/KeyValueDisplay'
import type { CommonStoreState } from '../store'
import { isNonemptyArray } from './common/utils'
import { Subtitle } from '@panwds/react-ui-legacy'

type DefaultAddonLicensesProps = {
  state: CommonStoreState,
  subTitle?: string,
}

const DefaultAddonLicenses: VFC<DefaultAddonLicensesProps> = ({ state }) => {
  if (state.loadingHashes) {
    return <></>
  }
  const renderAddOnElements: any[] = []
  const primaryAppDef = state?.manifest
  const primaryAppId = primaryAppDef?.primary_app_id || ''
  const addOnLicenses = state.licenses?.get(primaryAppId)?.licenses?.filter(e => e.product_type === 'addon')

  if (isNonemptyArray(addOnLicenses)) {
    renderAddOnElements.push(<KeyValueDisplay {...{ title: 'Add-ons', data: [] }} showTopDivider={true} />)
    addOnLicenses.forEach(e => {
      renderAddOnElements.push(<Subtitle size='sm' as='div'>{e.license_display_name}</Subtitle>)
    })
  }

  if (renderAddOnElements.length) {
    return <>{renderAddOnElements.map(e => e)}</>
  }
  return <></>
}

export default DefaultAddonLicenses
